import { render } from "./LayOut.vue?vue&type=template&id=2da1eeca&scoped=true"
import script from "./LayOut.vue?vue&type=script&lang=js"
export * from "./LayOut.vue?vue&type=script&lang=js"

import "./LayOut.vue?vue&type=style&index=0&id=2da1eeca&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da1eeca"]])

export default __exports__